import { FilterObjectWrapper } from '../wrappers/filter.object.wrapper';
import { FilterDataPointWrapper } from '../wrappers/filter.datapoint.wrapper';
import { FilterObject } from '../models/filter/filter.object';
import { Fldr } from '../models/datapoint/fldr';
import { ListUtil } from '../utils/list.util';
import { FilterDataObjectWrapper } from '../wrappers/filter.dataobject.wrapper';
import { FilterSequenceWrapper } from '../wrappers/filter.sequence.wrapper';
import { FilterDesignWrapper } from '../wrappers/filter.design.wrapper';
import { CommonEnums } from '../common.enums';
import { FilterUdfWrapper } from '../wrappers/filter.udf.wrapper';
import { FilterDBFUNWrapper } from '../wrappers/filter.dbfun.wrapper';
import { FilterStreamWrapper } from '../wrappers/filter.stream.wrapper';
import { RecentObjectsCache } from './recentobjects.cache';
import { DIMsgObj } from '../models/dimsgobj';
import { SessionFactory } from './session.factory';
import { FilterDataConnectWrapper } from '../wrappers/filter.dataconnect.wrapper';
import { FilterDataStreamWrapper } from '../wrappers/filter.datastream.wrapper';
import { Conn_Db_Node } from '../models/beans/conn_db_node';
import { FldrObjectWrapper } from '../wrappers/fldrobject.wrapper';
import { SessionExpiredPopupComponent } from 'src/app/shared/session/sessionexpired/sessionexpired-popup.component';
import { FilterDataSubFlowWrapper } from '../wrappers/filter.datasubflow.wrapper';
import { GlobalExceptionHandlerPopupComponent } from '../popups/globalexceptionhandler/globalexceptionhandler-popup.component';
import { UnsavedObjectsPopupComponent } from '../popups/unsaved/unsavedobjects-popup.component';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { ForcibleDeletePopupComponent } from '../popups/forcibledelete/components/forcibledelete-popup.component';
import { OpenDependenciesPopupComponent } from '../popups/open-dependencies-popup/components/open-dependencies-popup.component';

export class ListFactory {
  private static instance: ListFactory;

  static getInstance() {
    if (!ListFactory.instance) {
      ListFactory.instance = new ListFactory();
    }
    return ListFactory.instance;
  }

  selectedObjectWrapper: ObjectWrapper;

  setStart_Ts: Date;
  setEnd_Ts: Date;

  fldrObjectWrapper: FldrObjectWrapper;
  filterObjectWrappers: Array<FilterObjectWrapper>;
  filterDataPointWrapper: FilterDataPointWrapper;
  filterDataObjectWrapper: FilterDataObjectWrapper;
  filterDesignWrapper: FilterDesignWrapper;
  filterSequenceWrapper: FilterSequenceWrapper;
  filterDataSubFlowWrapper: FilterDataSubFlowWrapper;
  filterUdfWrapper: FilterUdfWrapper;
  filterDbfunWrapper: FilterDBFUNWrapper;
  filterStreamWrapper: FilterStreamWrapper;
  filterDataConnectWrapper: FilterDataConnectWrapper;
  filterDataStreamWrapper: FilterDataStreamWrapper;
  recentObjectsFactory: RecentObjectsCache;

  parameterObjects: Array<any>;
  connSrcObjects: Array<Conn_Db_Node>;
  selectedSrcItems: Array<any>
  selectedGridObjects: Array<any>;

  selectedChartObject: string;
  firstLevel_Cd: string;
  pageTitle: string;
  movedToUrl: string;
  changeFldr: Fldr;
  secondLevel_Cd = '';
  secondLevel_Cd1 = '';
  // selectedItemsHMap: Map<number, any>;

  fldrListObjects: Array<Fldr>;
  listUtil: ListUtil;

  filterByConnNm: string = '';
  filterByConn_Id: number = -1;
  filterByConnDbNm: string = '';

  attributeNames: Array<string>;

  isFetchData: boolean;
  isFetching: boolean;
  sessionFactory: SessionFactory;
  savedMessageBar: string;

  createNewFromLeftMenu: boolean;
  createMaskingFromLeftMenu: boolean;
  createDMWizardFromLeftMenu: boolean;
  importSchemaFromLeftMenu: boolean;
  calledMethod: string;

  sessionExpiredPopupId: SessionExpiredPopupComponent;
  //forcibleDeletePopupId: ForcibleDeletePopupComponent;
  globalErrorHandlerPopupId: GlobalExceptionHandlerPopupComponent;
  unsavedObjectsPopupId: UnsavedObjectsPopupComponent;
  opendependenciesPopupId:OpenDependenciesPopupComponent;
  unsavedObjectsResponse: boolean;
  reusableFlag: string;
  streamingFlg: string;
  dataflowAdd: any;
  // forcibleDeleteErrorMsg :string;
  addToJobFlow: boolean;

  sessionExpired: boolean;
  isImport: boolean;
  debugFlag: string;
  isTourStarted: boolean;
  tour1: any;
  eventSource: EventSource;
  /**
   * ListFactory is a singleton class, so use ListFactory.getInstance() method instead of creating new ListFactory().
   */
  private constructor() {
    this.sessionExpired = false;
    this.isImport = false;
    this.isTourStarted = false;
    this.filterObjectWrappers = new Array<FilterObjectWrapper>();

    //  this.filterDataPointWrapper = new FilterDataPointWrapper();
    //  this.filterDataObjectWrapper = new FilterDataObjectWrapper();
    this.filterSequenceWrapper = new FilterSequenceWrapper();
    this.filterDesignWrapper = new FilterDesignWrapper();
    this.filterStreamWrapper = new FilterStreamWrapper();
    this.filterUdfWrapper = new FilterUdfWrapper();
    this.filterDbfunWrapper = new FilterDBFUNWrapper();
    this.filterDataConnectWrapper = new FilterDataConnectWrapper();
    this.filterDataStreamWrapper = new FilterDataStreamWrapper();
    this.filterDataSubFlowWrapper = new FilterDataSubFlowWrapper();

    this.parameterObjects = new Array<any>();

    this.attributeNames = new Array<string>();
    this.connSrcObjects = new Array<Conn_Db_Node>();
    this.selectedSrcItems = new Array<any>()

    this.fldrListObjects = new Array<Fldr>();
    this.listUtil = ListUtil.getInstance();
    this.recentObjectsFactory = RecentObjectsCache.getInstance();

    this.firstLevel_Cd = CommonEnums.codes.HOME_PAGE;
    this.pageTitle = '';
    this.movedToUrl = '';
    this.changeFldr = null;
    this.isFetchData = true;
    this.isFetching = true;
    this.createNewFromLeftMenu = false;
    this.createMaskingFromLeftMenu = false;
    this.createDMWizardFromLeftMenu = false;
    this.importSchemaFromLeftMenu = false;
    this.sessionFactory = SessionFactory.getInstance();
    this.savedMessageBar = '';
    this.selectedChartObject = '';
    this.calledMethod = '';
    this.unsavedObjectsResponse = false;
    this.addToJobFlow = false;
    this.debugFlag = CommonEnums.defaults.STRING_VAL_NO;

    // this.forcibleDeleteErrorMsg = CommonEnums.defaults.STRING_EMPTY;

  }

  clearAllListScreenObjects(): void {
    this.parameterObjects.splice(0, this.parameterObjects.length);
  }

  showSessionExpiredPopup(): void {
    this.sessionExpiredPopupId.show();
  }

  // showForcebleDeletePopup(): void {
  //   this.forcibleDeletePopupId.show();
  // }

  setDefaultStartLimitEndLimit(filterObject: FilterObject, listItems: Array<any>) {
    filterObject.startLimit = 1;
    filterObject.endLimit = this.sessionFactory.listPageSize;
    listItems.splice(0, listItems.length);
  }

  setStartEndLimit(filterObject: FilterObject, listItems: Array<any>, isLoadAll: boolean = false): FilterObject {
    if (listItems.length == 0) {
      filterObject.startLimit = 1;
      filterObject.endLimit = this.sessionFactory.listPageSize;
      return filterObject;
    }

    filterObject.startLimit = listItems.length + 1;
    if (!isLoadAll) {
      filterObject.endLimit = filterObject.startLimit + this.sessionFactory.listPageSize - 1;
    } else {
      filterObject.endLimit = -1;
    }

    return filterObject;

  }

  getFilterObject(obj_Cd: string, objNm: string, fldr_Id: number, org_Id: number = -1, reusableFlag: string = 'N', aliasNm: string = '',
    dbTyp_Id: number, conn_Ids: Array<string>, dbTyp_Ids: Array<number>) {

    let filterObject: FilterObject = new FilterObject();

    filterObject.obj_Cd = obj_Cd;
    filterObject.objNm = objNm;
    filterObject.fldr_Id = fldr_Id;
    filterObject.org_Id = org_Id;
    filterObject.reUsableFlag = reusableFlag;
    filterObject.aliasNm = aliasNm;

    filterObject.dbTyp_Id = dbTyp_Id;
    filterObject.dbTyp_Ids = dbTyp_Ids;
    filterObject.conn_Ids = conn_Ids;

    filterObject.searchText = '*';
    filterObject.defaultFlag = 'N';

    return filterObject;
  }

  getMonitorFilterObject(objCd, objNm, fldr_Id, org_Id, reusableFlag, obj_Id) {
    let filterObject = new FilterObject()

    filterObject.obj_Cd = objCd;
    filterObject.objNm = objNm;
    filterObject.fldr_Id = fldr_Id;
    filterObject.org_Id = org_Id;
    filterObject.reUsableFlag = reusableFlag;
    filterObject.dxMp_Id = obj_Id;

    return filterObject;
  }


  setSavedMessageEmpty() {
    this.savedMessageBar = "";
  }


  getGlobalAccessReusableFldrListObjects(includeFldr_Ids) {
    let _reusableFldrListObjects = [];
    for (let i = 0; i < this.fldrListObjects.length; i++) {
      let fldrListObject = this.fldrListObjects[i];
      if (fldrListObject.reusableFlag == 'N') {

        if (includeFldr_Ids.indexOf(fldrListObject.fldr_Id) != -1)
          _reusableFldrListObjects.unshift(fldrListObject);

        continue;
      }

      if (this.checkGlobalAccessPrivileges(fldrListObject.fldr_Id, -1) &&
        (this.sessionFactory.hasAdminAccess == 'N')) {
        _reusableFldrListObjects.push(fldrListObject);
      }

      if (this.sessionFactory.hasAdminAccess == 'Y') {
        _reusableFldrListObjects.push(fldrListObject);
      }


    }

    return _reusableFldrListObjects;
  }

  checkGlobalAccessPrivileges(fldr_Id, layer_Id) {

    if (layer_Id == -1 || !layer_Id) {
      let str = fldr_Id + 'GUP';
    } else {
      let str = fldr_Id + 'GUP' + layer_Id;
    }

    // if( factoryObj.privileges.indexOf(str) != -1 )
    //   return true;
    return true;
  }


  setSelectedObjectList(obj_Id: number, obj_Cd: string, stateParams: any = {}) {

    let obj_IdsHMap = {};
    obj_IdsHMap[obj_Id] = obj_Cd;

    let diMsgObject: DIMsgObj = new DIMsgObj();
    diMsgObject.persistVal = obj_IdsHMap;
    diMsgObject.refFlg = 'N';

    if (stateParams && stateParams.reusableFlag == 'Y') {
      diMsgObject.refFlg = 'Y';
    }
    return diMsgObject;
  }

  getrepFolder(obj_Id) {
    for (let i = 0; i < this.parameterObjects.length; i++) {
      if (this.parameterObjects[i].obj_Id == obj_Id)
        return this.parameterObjects[i];
    }
  }

  // --------------
  getFolderName(fldr_Id) {
    let fldrListObject = this.getFldrListObject(fldr_Id);
    if (!fldrListObject) return '';
    return fldrListObject.nm;
  }

  getFldrListObject(fldr_Id) {
    for (let i = 0; i < this.fldrListObjects.length; i++) {
      let fldrListObject = this.fldrListObjects[i];
      if (fldrListObject.fldr_Id == fldr_Id)
        return fldrListObject;
    }
    return null;
  }


  getFolderReusableFlag(fldr_Id) {
    let fldrListObject = this.getFldrListObject(fldr_Id);
    if (!fldrListObject) return '';

    return fldrListObject.reusableFlag;
  }

  addGridObject(gridObject): void {
    switch (gridObject.obj_Cd) {
      case 'NSEQ':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'UDF':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'DBFN':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'CONN':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'DOBJ':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'DXMP':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      case 'DXFLOW':
        this.listUtil.addItem(this, gridObject, gridObject.obj_Cd);
        this.recentObjectsFactory.addUsr_Log(gridObject);
        break;
      default: break;
    }
  }

  setEmptyfilterConnDobj() {
    this.filterByConnDbNm = "";
    this.filterByConnNm = "";
    this.filterByConn_Id = -1;
  }
}